import { Activity, KeyRound, PlugZap, ServerCog } from "lucide-react";
import { useI18n } from "../../../i18n";
import { fmtDateTime } from "../../../lib/format";
import { StatCard } from "../../../components/common/StatCard";

const when = (iso) => <span className="whitespace-normal text-sm sm:text-base">{iso ? fmtDateTime(iso) : "—"}</span>;

export const StatusPanel = ({ health, onLogin, loggingIn }) => {
  const { t } = useI18n();
  const s = health.settings;
  const session = health.session || {};
  return (
    <section className="space-y-3">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <StatCard testId="softone-mode" icon={ServerCog} label={t("softone.mode")} value={health.mode === "mock" ? "MOCK" : "LIVE"} tone={health.mode === "mock" ? "navy" : "green"} hint={s.configured ? t("softone.configured") : t("softone.notConfigured")} />
        <StatCard testId="softone-last-login" icon={KeyRound} label={t("softone.lastLogin")} value={when(session.last_login_at)} />
        <StatCard testId="softone-last-success" icon={PlugZap} label={t("softone.lastSuccess")} value={when(session.last_success_at)} tone="green" />
        <StatCard testId="softone-calls-24h" icon={Activity} label={t("softone.calls24h")} value={`${health.calls_24h.total} / ${health.calls_24h.failed}`} hint={t("softone.callsHint")} tone={health.calls_24h.failed ? "red" : "green"} />
      </div>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 rounded-2xl bg-white px-5 py-4 text-xs text-slate-600 shadow-sm" data-testid="softone-settings">
        <span>URL: <b className="text-navy">{s.url || "—"}</b></span>
        <span>User: <b className="text-navy">{s.username || "—"}</b></span>
        <span>AppID: <b className="text-navy">{s.app_id_set ? "✓" : "—"}</b></span>
        <span>Company/Branch/Module/RefID: <b className="text-navy">{[s.company, s.branch, s.module, s.refid].map((v) => v || "—").join(" / ")}</b></span>
        <span>{t("softone.orderSeries")}: <b className="text-navy">{s.order_series}</b></span>
        <span>{t("softone.testSeries")}: <b className="text-navy">{s.test_series}</b></span>
        {session.last_error && (!session.last_success_at || !session.last_error_at || session.last_error_at > session.last_success_at) && <span className="text-rose-600" data-testid="softone-last-error">{t("softone.lastError")}: {session.last_error}</span>}
        <button type="button" onClick={onLogin} disabled={loggingIn} data-testid="softone-login-button" className="ml-auto h-11 rounded-full bg-navy px-5 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-50">
          {t("softone.testLogin")}
        </button>
      </div>
    </section>
  );
};
